import script from "./TableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TableWidget.vue?vue&type=script&setup=true&lang=js"

import "./TableWidget.vue?vue&type=style&index=0&id=d28e7ade&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d28e7ade"]])

export default __exports__